import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PlaylistStateModel } from 'models/photo/playlist-ads.model';
import { getPlaylistApiAction } from 'store/api/playlist-ads.slice-api';

const initialState: PlaylistStateModel = {
  mediaPlaylist: {
    data: [],
    totalRecord: 0,
  },
  loadingInList: false,
};

export const playListSlice = createSlice({
  name: 'playlist-ads',
  initialState,
  reducers: {
    setPlaylistStateAction: (
      state,
      action: PayloadAction<Partial<PlaylistStateModel>>,
    ) => ({ ...state, ...action?.payload }),
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(getPlaylistApiAction.matchPending, (state) => ({
        ...state,
        loadingInList: true,
      }))
      .addMatcher(getPlaylistApiAction.matchRejected, (state) => ({
        ...state,
        loadingInList: false,
      }))
      .addMatcher(
        getPlaylistApiAction.matchFulfilled,
        (state, { payload }) => ({
          ...state,
          mediaPlaylist: {
            data: payload?.data ?? [],
            totalRecord: payload?.totalRecord ?? 0,
          },
        }),
      );
  },
});

export const { setPlaylistStateAction } = playListSlice.actions;

export default playListSlice.reducer;
